/* eslint-disable import/prefer-default-export */
export const progress = {
  0: '未联系',
  5: '排队中',
  1: '联系中',
  2: '已联系',
  3: '已暂停',
  4: '已取消',
};

export const status = {
  0: '未开始',
  1: '进行中',
  2: '已暂停',
  3: '已取消',
  4: '已完成',
};
export const taskStatu = {
  0: '未开始',
  1: '进行中',
  2: '已暂停',
  3: '已取消',
  4: '已完成',
};
export const result = {
  0: '无法接通',
  1: '空号',
  2: '接听后挂断',
  5: '转人工',
  10: '无人接听',
  11: '占线',
  12: '关机',
  13: '停机',
  14: '号码错误',
  15: '网络异常',
  16: '其他异常',
  90: '超出时效',
  97: '风控拦截',
  99: '企业过期',
};

export const result2 = {
  0: '无法接通',
  1: '空号',
  2: '接听后挂断',
  5: '转人工',
  10: '无人接听',
  11: '正在通话中',
  12: '关机',
  13: '停机',
  14: '改号',
  15: '网络忙',
  16: '未知的原因',
};
